import createReactComponent from '../createReactComponent';
var Save = createReactComponent('Save', [['path', {
  d: 'M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z',
  key: '1q2m9t'
}], ['polyline', {
  points: '17 21 17 13 7 13 7 21',
  key: '1md35c'
}], ['polyline', {
  points: '7 3 7 8 15 8',
  key: '8nz8an'
}]]);
export default Save;